import request from '@/router/axios'

export function getMedalGroupList(params) {
  return request({
    url: '/medal/admin/medal-group',
    method: 'GET',
  })
}

export function getMedalGroupPage(params) {
  return request({
    url: '/medal/admin/medal-group/page',
    method: 'GET',
    params: params
  })
}

export function syncMedalGroupCache() {
  return request({
    url: '/medal/admin/medal-group/sync-cache',
    method: 'put',
  })
}

export function deleteMedalGroupById(id) {
  return request({
    url: '/medal/admin/medal-group/' + id,
    method: 'DELETE',
  })
}

export function addGroupObj(obj) {
  return request({
    url: '/medal/admin/medal-group',
    method: 'post',
    data: obj
  })
}

export function updateGroupObj(obj) {
  return request({
    url: '/medal/admin/medal-group',
    method: 'put',
    data: obj
  })
}

export function getMedalList(params) {
  return request({
    url: '/medal/admin/page',
    method: 'GET',
    params: params
  })
}

export function getMedalDetail(id) {
  return request({
    url: '/medal/admin/' + id,
    method: 'GET',
  })
}

export function createMedal(obj) {
  return request({
    url: '/medal/admin',
    method: 'post',
    data: obj
  })
}

export function updateMedal(obj) {
  return request({
    url: '/medal/admin',
    method: 'put',
    data: obj
  })
}

export function getMemberMedalRecordPage(params) {
  return request({
    url: '/medal/admin/medal-record//member/page',
    method: 'GET',
    params: params
  })
}

export function getMedalMemberRecordList(params) {
  return request({
    url: '/medal/admin/medal-record/page',
    method: 'GET',
    params: params
  })
}

export function issueMedal(data) {
  return request({
    url: '/medal/admin/medal-record/add',
    method: 'POST',
    data: data
  })
}

export function getMemberInfo(id) {
    return request({
      url: '/admin/admin/member/unionId/' + id,
      method: 'GET',
    })
  }

export function enableMedal (id) {
  return request({
    url: '/medal/admin/status/' + id,
    method: 'POST',
    params: {
        isActive : true
    }
  })
}

export function disableMedal (id) {
  return request({
    url: '/medal/admin/status/' + id,
    method: 'POST',
    params: {
        isActive : false
    }
  })
}

export function syncMedalCache() {
  return request({
    url: '/medal/admin/sync-cache',
    method: 'put',
  })
}
